/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  params, useDataModel, extend,
  number as numberType,
  shape as shapeType,
} from '@thd-nucleus/data-sources';
import classNames from 'classnames';
import {
  Card,
  CardTitle,
  CardBody,
  Typography
} from '@one-thd/sui-atomic-components';
import { Duplicate } from '@one-thd/sui-icons';
import { AddToContext } from '../../AddToContext';
import { AddToCoreContext } from '../../core/AddToCoreContext';
import { TRACK, SCREENS } from '../../AddToConstants';
import { triggerAnalytics } from '../../AddToHelpers';

export const CopyListTile = ({ isEnabled: isEnabledProp }) => {
  const addToContext = useContext(AddToContext);
  const coreContext = useContext(AddToCoreContext);
  // Prefer AddToCoreContext when available (core flow); fall back to AddToContext (legacy flow)
  const setScreen = coreContext.screen !== null ? coreContext.setScreen : addToContext.setScreen;
  const addToType = coreContext.addToType || addToContext.addToType;
  const { data: listsData } = useDataModel('lists', {
    variables: {},
    context: { withAuth: true },
    skip: isEnabledProp !== undefined
  });

  const isProjectType = addToType === 'Project';
  const minimumListCount = isProjectType ? 0 : 1;
  const isListsTileEnabled = isEnabledProp !== undefined
    ? isEnabledProp
    : listsData?.lists?.pagination?.totalResults > minimumListCount;

  const handleTileClick = () => {
    // 7.1 Copy from Your Lists selection - when drawer opens
    const payload = isProjectType ? { flowType: 'projects' } : undefined;
    triggerAnalytics(TRACK.ADD_TO_LIST_COPY_FROM_LISTS_SELECTION, payload);
    setScreen(SCREENS.COPY_LIST_SUMMARY);
  };

  const copyListTileWrapperClass = classNames(
    'sui-mt-5 sui-cursor-pointer sui-bg-subtle',
    {
      'sui-pointer-events-auto': isListsTileEnabled,
      'sui-pointer-events-none': !isListsTileEnabled
    }
  );
  return (
    <div
      onClick={handleTileClick}
      className={copyListTileWrapperClass}
    >
      <Card
        data-testid="copy-list"
        disablePadding
        disableGutters
        orientation="horizontal"
        className={`${isListsTileEnabled ? null : 'sui-bg-subtle'}`}
      >
        <div className="sui-w-24 sui-flex sui-justify-center sui-items-center">
          <Duplicate size="large" color={isListsTileEnabled ? 'primary' : 'subtle'} />
        </div>
        <div className="sui-py-3 sui-pr-1">
          <CardTitle
            header={(
              <Typography
                variant="h3"
                color={isListsTileEnabled ? 'primary' : 'inactive'}
              >
                Copy from Your Lists
              </Typography>
            )}
          />
          <CardBody>
            <Typography
              color={isListsTileEnabled ? null : 'inactive'}
            >
              Reuse items from your existing lists.
            </Typography>
          </CardBody>
        </div>
      </Card>
    </div>
  );
};

CopyListTile.displayName = 'CopyListTile';

CopyListTile.propTypes = {
  isEnabled: PropTypes.bool,
};

CopyListTile.defaultProps = {
  isEnabled: undefined,
};

CopyListTile.dataModel = extend({
  lists: params({ page: numberType(), pageSize: numberType() }).shape({
    pagination: shapeType({
      totalResults: numberType(),
    })
  })
});
